import type { Logger } from "@expert/logging";
import ky from "ky";
import { defaultHeaders, defaultTimeoutInMS } from "../types";
import type { DefaultPayload } from "./types";

type GeneratePasscodePayload = DefaultPayload & {
    mdn: string;
};

export interface GeneratePasscodeResult {
    success: boolean;
    transactionId: string;
}

export const generatePasscode = async (
    ssoAccessToken: string,
    payload: GeneratePasscodePayload,
    lookupCountMdnsToken: string,
    logger: Logger,
) => {
    try {
        const url = `${import.meta.env.VITE_API_BASE_URL}/api/device-activation/v1/generate-passcode`;
        const resp = await ky.post(url, {
            headers: {
                ...defaultHeaders,
                Authorization: `Bearer ${ssoAccessToken}`,
            },
            json: { ...payload, token: lookupCountMdnsToken },
            timeout: defaultTimeoutInMS,
        });

        const result = await resp.json<GeneratePasscodeResult>();
        return result;
    } catch (error) {
        logger.error({ error }, `Error: Could not generate passcode for customer MDN.`);
        return { success: false, transactionId: "" };
    }
};
